import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_WIDGET_TYPE'),
  ...asyncTypes('GET_WIDGET_VISIBILITY'),
  ...asyncTypes('UPDATE_WIDGET_VISIBILITY')
};

export default TYPES;
